import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {AppBaseComponent} from '../../../commons/AppBaseComponent';
import {Dataset, FourDService, Transform, TransformGroup} from '4d-mapper';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {AppService} from '../../../commons/app.service';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {MainService} from '../../main.service';
import {MapService} from '../../../commons/map.service';
import {of, Subscription} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {MapComponent} from '../map.component';
import {Location} from '@angular/common';
import { XsApplicationEventsService } from '../../../xs/services/events/application-events.service';
import { Constants } from '../../../commons/Constants';

const Cesium = (<any>window).Cesium

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent extends AppBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  id:any = null;

  guide:any = null;

  layers:any = null;

  constructor(private fourD: FourDService, public service: AppService, private r: Router, sn: MatSnackBar, d: MatDialog, private t: TranslateService, private mainService: MainService, private trans: TranslateService,
              private mapService: MapService, private httpClient: HttpClient, private ar: ActivatedRoute, private mapComp: MapComponent, private location: Location, applicationEvents:XsApplicationEventsService) {
    super(service, r, sn, d, applicationEvents);
    this.mapComp.detailsNav.open();
  }

  init() {
    this.layers = this.mapComp.layerComp;
    console.log ( '### open details GUIDE');
  }

  ngAfterViewInit() {
    this.loading = false;

    this.ar.params.subscribe(s => {

      if ( this.id ) {
        this.mapComp.detailsNav.close();
      }

      this.id = s.id;

      if ( this.layers && this.layers.currentScene && this.layers.currentScene['cameras'] ) {
        this.guide = this.layers.currentScene['cameras'].find( c => c.id == this.id );
      }
      
      if ( ! this.guide ) {

        this.mapComp.detailsNav.close();
        this.router.navigate(["../../"],      {relativeTo: this.ar});

      } else {

        this.layers.selectedGuide = this.id;
        this.flyTo();

      }

      console.log ( '@@@@@@@@@@@@@@@@@@', s, this, this.layers.currentScene );

    })

  }

  close() {
    this.mapComp.detailsNav.close();
    this.router.navigate(['../../'], { relativeTo: this.ar });
  }

  save () {
    this.close();
  }

  destroy() {
    this.layers.selectedGuide = null;
    this.close();
  }

  delete() {
    this.layers.deleteCamera(this.guide);
    this.close();
  }

  flyTo() {
    this.layers.flyToCamera(this.guide);
  }

  snapCamera() {
    this.layers.snapCamera (this.guide);
  }
}
